import { Col, InputNumber, Row } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../../reducers/LocaleReducer/LocalReducer'

const QuotaAllocationForm = ({ disabled, places, onPlacesChanged }) => {
  const t = useSelector(selectTranslate)

  const handlePlaceChange = places => {
    if (Number.isInteger(places)) {
      onPlacesChanged(places)
    }

    if (places === '') {
      onPlacesChanged(0)
    }
  }

  return (
    <div className='allocate-quota-form'>
      <Row>
        <Col span={12}>
          <h4>
            <b>
              {t('allocation_form.places')}
            </b>
          </h4>
        </Col>
        <Col span={12}>
          <InputNumber
            value={places ?? 0}
            onChange={handlePlaceChange}
            disabled={disabled}
          />
        </Col>
      </Row>
    </div>
  )
}

export default QuotaAllocationForm
